import { Store } from '../../../store/player/types';
import { jumpTo } from './jumpTo';

/**
 * Restart the recording.
 */
export const restart = (store: Store): void => {
  const { setPlaying } = store.getState();

  // Start playback before jumpTo, otherwise recording resets to a paused state.
  setPlaying(true);

  // On reset we jumpTo 0 since we need to reset the DOM back to its original state.
  // This is needed to reset rules that were added using the inserted_rules recording event.
  jumpTo(store, 0);
};
